import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http';
import { HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../components/error-dialog/error-dialog.component';
import { ErrorService } from '../services/error-service.service';

export function openErrorDialog(dialog: MatDialog, title: string, message: string, errorCode: string): void {
  const dialogRef = dialog.open(ErrorDialogComponent, {
    data: {
      title: title,
      message: message,
      errorCode: errorCode
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log(`Dialog result: ${result}`);
  });
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private currentError: string = '';

  constructor(
    private dialog: MatDialog,
    private errorService: ErrorService
  ) {
    this.errorService.currentError.subscribe(error => {
      this.currentError = error;
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          console.log('this is client side error');
          console.log(`Error: ${error.error.message}`);
          openErrorDialog(this.dialog, 'Error', 'An error occurred. Please try again later.', this.currentError);
        }
        else {
          console.log('this is server side error');
          console.log(`Error Code: ${error.status},  Message: ${error.message}`);
          openErrorDialog(this.dialog, 'Error', 'An error occurred. Please try again later.', this.currentError);

        }
        return throwError(() => error);
      })
    );
  }
}
